import { createContext, useContext } from "react";
export const useClient = () => {
    const { client } = useContext(ConfigContext);
    if (!client) {
        throw Error('remote endpoint not defined');
    }
    return client;
};
export const ConfigContext = createContext({ editable: false });
//# sourceMappingURL=config.js.map